/**
 * Admin theme.
 *
 * The panel serves a single facade, so the QR Phone theme IS the admin theme.
 * The token set + factory split is kept so the identity stays tunable in one
 * place (src/themes/qrPhoneTheme.ts).
 */

import { qrPhoneTheme } from './qrPhoneTheme';

/** The admin theme (the QR Phone corporate identity). */
export const adminTheme = qrPhoneTheme;

export { qrPhoneTheme };
export { createAdminTheme } from './createAdminTheme';
export type { BrandTokens } from './createAdminTheme';
